import styles from "./carouselButton.module.scss";
import PropTypes from "prop-types";

const CarouselButton = ({
  prev,
  next,
  className,
  variant,
  btnSize,
  btnColor,
  btnTheme,
  handleClick,
  id
}) => {
  const handleButtonClick = (e) => {
    e.preventDefault();
    if (handleClick) {
      handleClick();
    }
  }
  return (
    <div className={`${className} ${styles["owl--" + variant]} ${styles[btnTheme]}`} >
      {next && (
        <div
          className={`owl--next  ${styles["btn"]} 
          ${styles["btn--" + btnSize]}
          ${styles["btn--next"]}`}
          onClick={(event) => handleButtonClick(event)}
          id={id}
        >
          <div className={styles["btn__arrow"]}>
            <i
              className={`v-icon-chevron-right ${styles[`${btnColor}`]} ${
                styles[`icon__${btnSize}`]
                }`}
            ></i>
          </div>
          <div className={styles[`btn__${btnSize}`]}></div>
        </div>
      )}
      {prev && (
        <div
          className={`owl--prev  ${styles["btn"]} 
          ${styles["btn--" + btnSize]}
          ${styles["btn--prev"]}`}
          onClick={(event) => handleButtonClick(event)}
          id={id}
        >
          <div className={styles["btn__arrow"]}>
            <i
              className={`v-icon-chevron-left ${styles[`${btnColor}`]} ${
                styles[`icon__${btnSize}`]
                }`}
            ></i>
          </div>
          <div className={styles[`btn__${btnSize}`]}></div>
        </div>
      )}
    </div>
  );
};

CarouselButton.propTypes = {
  prev: PropTypes.bool,
  next: PropTypes.bool,
  variant: PropTypes.oneOf(["arc", "oval", "clear"]),
  className: PropTypes.string,
  handleClick: PropTypes.func,
  btnSize: PropTypes.oneOf(["sm", "bg"]),
  btnColor: PropTypes.oneOf(["black", "white"]),
  btnTheme: PropTypes.string
};

CarouselButton.defaultProps = {
  className: "",
  variant: "arc",
  btnSize: "bg",
  btnColor: "white",
  btnTheme: "dark"
};

export default CarouselButton;
